import { getCssSizeValue, getHtmlFromRedactorField, getPaddingsClassFromData } from "@/utils/utils"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import LinkButton from "@/components/common/Buttons/LinkButton"
import { BREAKPOINTS } from "@/styles/themeSettings"

const StyledSingleJobOffer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 20px;
	background: ${({ theme }) => theme.colors.platinum};
	padding-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	aspect-ratio: 427/512;
	width: 100%;
	height: auto;
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-bottom: ${getCssSizeValue(32)};
		margin-bottom: unset;
	}

	.button {
		margin-left: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-left: ${getCssSizeValue(32)};
		}
	}
`

const Header = styled.div`
	display: flex;
	align-items: center;
	background: ${({ theme }) => theme.colors.gunmetal};
	color: ${({ theme }) => theme.colors.whiteSmoke};
	padding: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	width: 100%;
	height: auto;
	aspect-ratio: 427/86;

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(19)} ${getCssSizeValue(32)};
	}

	> div {
		width: 90%;
	}
`

const Description = styled.div`
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(32)};
		padding-left: ${getCssSizeValue(52)};
	}
`

function SingleJobOffer({ data }) {
	const header = data?.header || ""
	const description = data?.description || ""

	return (
		<StyledSingleJobOffer className="col-desktop-4 col-mobile-8">
			<div>
				<Header>
					<div className="typo-borna typo-borna-104" dangerouslySetInnerHTML={getHtmlFromRedactorField(header)} />
				</Header>
				<Description
					tag="div"
					className="typo-strawford typo-strawford-14"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}
				/>
			</div>
			<LinkButton data={data?.button} />
		</StyledSingleJobOffer>
	)
}

export default function CareerModule({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const jobOffers = data?.jobOffers || []

	return (
		<GridContainer className={paddings}>
			{jobOffers.map((offer, index) => {
				const key = offer?.id || index

				return <SingleJobOffer key={key} data={offer} />
			})}
		</GridContainer>
	)
}
